import { Ref, useState } from 'react';
import { Spinner } from '../Icons';

export const Loader = (props: { nestWithinRef?: Ref<HTMLDivElement> }) => {
  let boundingBox: DOMRect | undefined = undefined;
  if (props.nestWithinRef && 'current' in props.nestWithinRef) {
    boundingBox = props.nestWithinRef.current?.getBoundingClientRect();
  }

  return (
    <div
      className={`fixed ${
        boundingBox
          ? `left-[${boundingBox.left}px] bottom-[${boundingBox.bottom}px] right-[${boundingBox.right}px] top-[${boundingBox.top}px]
            h-screen w-full min-h-[${boundingBox.height}] min-w-[${boundingBox.width}]`
          : 'left-0 top-0 z-50 flex h-screen w-full'
        } flex-col items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm`}
    >
      <output aria-live="polite" aria-busy="true">
        {boundingBox ? (
          <div
            className={`absolute left-[${boundingBox.left + boundingBox.width / 2}] top-[${boundingBox.top + boundingBox.height / 2}]`}
          >
            <Spinner />
          </div>
        ) : (
          <Spinner />
        )}
      </output>
    </div>
  );
};
